import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const MaterialSymbol = React.forwardRef(({ children, className, style, ...rest }, ref) => {
    return (
        <span
            ref={ref}
            aria-hidden="true"
            className={cx("material-symbols-outlined", className)}
            style={style}
            {...rest}
        >
            {children}
        </span>
    );
});

export default MaterialSymbol;

MaterialSymbol.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};
